export default __webpack_public_path__ + "static/media/stk.c2b3e96f.svg";